import React, { useState } from 'react';
import EmailSignupForm from '../EmailSignupForm';
import '../../pages/LandingPage.css';
import SectionBackground from './SectionBackground';

interface TenantData {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
}

const DemoSection: React.FC = () => {
  const [tenants, setTenants] = useState<TenantData[]>([
    { id: 1, firstName: '', lastName: '', email: '', phone: '' }
  ]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [showSuccess, setShowSuccess] = useState(false);

  const addTenant = () => {
    const newId = Math.max(...tenants.map(t => t.id)) + 1;
    setTenants([...tenants, { id: newId, firstName: '', lastName: '', email: '', phone: '' }]);
  };

  const removeTenant = (id: number) => {
    if (tenants.length > 1) {
      setTenants(tenants.filter(t => t.id !== id));
    }
  };

  const handleSignupSuccess = () => {
    setShowSuccess(true);
    setTimeout(() => setShowSuccess(false), 5000);
  };

  return (
    <SectionBackground style={{
      padding: '40px 20px 80px',
      background: 'var(--bg-light)',
    }}>
      <div className="container">
        <div style={{
          background: 'var(--bg-white)',
          borderRadius: '16px',
          boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
          overflow: 'hidden',
        }}>
          {/* Demo Header */}
          <div style={{
            background: 'linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 100%)',
            color: 'white',
            padding: '30px',
            textAlign: 'center',
          }}>
            <h3 style={{ marginBottom: '10px', fontWeight: 700, fontSize: '1.75rem' }}>
              Try It Now - See How Easy It Is
            </h3>
            <p style={{ opacity: 0.9, fontSize: '1.1rem' }}>
              Fill out the form below to see exactly what you'll get
            </p>
          </div>

          {/* Form Content */}
          <div style={{ padding: '40px' }}>
            {/* Property Information */}
            <div style={{ marginBottom: '40px', paddingBottom: '40px', borderBottom: '1px solid var(--border)' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
                <div style={{
                  width: '32px',
                  height: '32px',
                  background: 'var(--primary)',
                  color: 'white',
                  borderRadius: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                  🏠
                </div>
                <h4 style={{ fontWeight: 700, fontSize: '1.25rem' }}>
                  Property Information
                </h4>
              </div>
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                gap: '16px',
              }}>
                <input
                  type="text"
                  placeholder="Street Address"
                  style={{
                    padding: '12px 16px',
                    border: '1px solid var(--border)',
                    borderRadius: '8px',
                    fontSize: '16px',
                  }}
                />
                <input
                  type="text"
                  placeholder="Unit/Apt #"
                  style={{
                    padding: '12px 16px',
                    border: '1px solid var(--border)',
                    borderRadius: '8px',
                    fontSize: '16px',
                  }}
                />
                <input
                  type="text"
                  placeholder="City"
                  style={{
                    padding: '12px 16px',
                    border: '1px solid var(--border)',
                    borderRadius: '8px',
                    fontSize: '16px',
                  }}
                />
                <input
                  type="text"
                  placeholder="ZIP Code"
                  style={{
                    padding: '12px 16px',
                    border: '1px solid var(--border)',
                    borderRadius: '8px',
                    fontSize: '16px',
                  }}
                />
              </div>
            </div>

            {/* Lease Terms */}
            <div style={{ marginBottom: '40px', paddingBottom: '40px', borderBottom: '1px solid var(--border)' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
                <div style={{
                  width: '32px',
                  height: '32px',
                  background: 'var(--primary)',
                  color: 'white',
                  borderRadius: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                  📋
                </div>
                <h4 style={{ fontWeight: 700, fontSize: '1.25rem' }}>
                  Lease Terms
                </h4>
              </div>
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                gap: '16px',
              }}>
                <input
                  type="date"
                  style={{
                    padding: '12px 16px',
                    border: '1px solid var(--border)',
                    borderRadius: '8px',
                    fontSize: '16px',
                  }}
                />
                <select style={{
                  padding: '12px 16px',
                  border: '1px solid var(--border)',
                  borderRadius: '8px',
                  fontSize: '16px',
                  background: 'white',
                }}>
                  <option value="">Select Lease Type...</option>
                  <option value="fixed">Fixed Term (6-12 months)</option>
                  <option value="month">Month-to-Month</option>
                </select>
                <div style={{ position: 'relative' }}>
                  <span style={{
                    position: 'absolute',
                    left: '12px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: 'var(--text-light)',
                  }}>$</span>
                  <input
                    type="number"
                    placeholder="Monthly Rent"
                    style={{
                      padding: '12px 16px 12px 32px',
                      border: '1px solid var(--border)',
                      borderRadius: '8px',
                      fontSize: '16px',
                      width: '100%',
                    }}
                  />
                </div>
                <div style={{ position: 'relative' }}>
                  <span style={{
                    position: 'absolute',
                    left: '12px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: 'var(--text-light)',
                  }}>$</span>
                  <input
                    type="number"
                    placeholder="Security Deposit"
                    style={{
                      padding: '12px 16px 12px 32px',
                      border: '1px solid var(--border)',
                      borderRadius: '8px',
                      fontSize: '16px',
                      width: '100%',
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Tenants */}
            <div style={{ marginBottom: '40px', paddingBottom: '40px', borderBottom: '1px solid var(--border)' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
                <div style={{
                  width: '32px',
                  height: '32px',
                  background: 'var(--primary)',
                  color: 'white',
                  borderRadius: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                  👥
                </div>
                <h4 style={{ fontWeight: 700, fontSize: '1.25rem' }}>
                  Tenants
                </h4>
              </div>
              
              {tenants.map((tenant, index) => (
                <div
                  key={tenant.id}
                  style={{
                    background: 'var(--bg-light)',
                    padding: '20px',
                    borderRadius: '12px',
                    marginBottom: '20px',
                    position: 'relative',
                  }}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                    <div style={{ fontWeight: 600 }}>Tenant {index + 1}</div>
                    {tenants.length > 1 && (
                      <button
                        onClick={() => removeTenant(tenant.id)}
                        style={{
                          background: 'none',
                          border: 'none',
                          color: 'var(--error)',
                          cursor: 'pointer',
                          fontSize: '20px',
                        }}
                      >
                        ✕
                      </button>
                    )}
                  </div>
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                    gap: '16px',
                  }}>
                    <input
                      type="text"
                      placeholder="First Name"
                      style={{
                        padding: '8px 12px',
                        border: '1px solid var(--border)',
                        borderRadius: '6px',
                        fontSize: '14px',
                      }}
                    />
                    <input
                      type="text"
                      placeholder="Last Name"
                      style={{
                        padding: '8px 12px',
                        border: '1px solid var(--border)',
                        borderRadius: '6px',
                        fontSize: '14px',
                      }}
                    />
                    <input
                      type="email"
                      placeholder="Email"
                      style={{
                        padding: '8px 12px',
                        border: '1px solid var(--border)',
                        borderRadius: '6px',
                        fontSize: '14px',
                      }}
                    />
                    <input
                      type="tel"
                      placeholder="Phone"
                      style={{
                        padding: '8px 12px',
                        border: '1px solid var(--border)',
                        borderRadius: '6px',
                        fontSize: '14px',
                      }}
                    />
                  </div>
                </div>
              ))}
              
              <button
                onClick={addTenant}
                style={{
                  width: '100%',
                  padding: '16px',
                  border: '2px dashed var(--primary)',
                  borderRadius: '8px',
                  background: 'transparent',
                  color: 'var(--primary)',
                  fontWeight: 600,
                  cursor: 'pointer',
                  fontSize: '16px',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderStyle = 'solid';
                  e.currentTarget.style.background = 'var(--primary)';
                  e.currentTarget.style.color = 'white';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderStyle = 'dashed';
                  e.currentTarget.style.background = 'transparent';
                  e.currentTarget.style.color = 'var(--primary)';
                }}
              >
                ➕ Add Another Tenant (No Extra Cost!)
              </button>
            </div>

            {/* Included Features */}
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
                <div style={{
                  width: '32px',
                  height: '32px',
                  background: 'var(--primary)',
                  color: 'white',
                  borderRadius: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                  ✨
                </div>
                <h4 style={{ fontWeight: 700, fontSize: '1.25rem' }}>
                  Included Features
                </h4>
              </div>
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                gap: '16px',
              }}>
                {[
                  'Pet Addendum',
                  'Parking Agreement',
                  'Utilities Breakdown',
                  'Move-in Checklist',
                  'Lead Paint Disclosure',
                  'AB 1482 Notice',
                ].map((feature) => (
                  <div
                    key={feature}
                    style={{
                      padding: '12px',
                      border: '2px solid var(--border)',
                      borderRadius: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                    }}
                  >
                    <input
                      type="checkbox"
                      checked
                      disabled
                      style={{ margin: 0 }}
                    />
                    <span>{feature}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div style={{
            background: 'linear-gradient(135deg, var(--success) 0%, #059669 100%)',
            padding: '60px 40px',
            textAlign: 'center',
            color: 'white',
          }}>
            <h3 style={{ marginBottom: '20px', fontWeight: 700, fontSize: '1.75rem' }}>
              Ready to Generate Your Lease?
            </h3>
            <p style={{ fontSize: '1.25rem', marginBottom: '30px', opacity: 0.9 }}>
              Get notified when TenantTerms launches and lock in our $1 pricing forever
            </p>
            
            <div style={{ maxWidth: '500px', margin: '0 auto' }}>
              <EmailSignupForm 
                formLocation="demo-cta" 
                onSuccess={handleSignupSuccess} 
                customClass="email-form" 
                inputClass="email-input" 
                buttonClass="submit-btn"
                buttonText="Let's Get Started"
                isSignupButton={true}
              />
              <p style={{ fontSize: '14px', opacity: 0.8, marginTop: '15px' }}>
                Join 500+ California landlords already on the waitlist
              </p>
            </div>
          </div>
        </div>
      </div>
    </SectionBackground>
  );
};

export default DemoSection; 